import React from 'react';
import { clearEmailPrefill, readEmailPrefill } from 'Utils/EmailPrefill';
import { isEmail, validateEmailOrPhone } from './SignUpForm';

/**
 * Turn a carried value into something safe to put in the email-or-phone field:
 * the value itself when it is an email address or phone number, otherwise ''.
 * A link that left the "+" of an address unencoded arrives with a space in its
 * place; an address cannot contain a space, so that one case is put back.
 */
export const normalizeEmailOrPhonePrefill = (value: string | undefined): string => {
  if (typeof value !== 'string' || !value) return '';
  if (validateEmailOrPhone(value)) return value;
  const withPlusRestored = value.replace(/ /g, '+');
  return isEmail(withPlusRestored) ? withPlusRestored : '';
};

/**
 * The email or phone number carried over from the other auth page or from the
 * link that opened this one ('' when there is none). Read once per mount and
 * then dropped, so it prefills one form and does not linger.
 */
export const useEmailOrPhonePrefill = (): string => {
  const [prefill] = React.useState(() => normalizeEmailOrPhonePrefill(readEmailPrefill()));

  React.useEffect(() => {
    clearEmailPrefill();
  }, []);

  return prefill;
};
